export const IconNames = {
  AddNew: 'add-new',
  AddReaction: 'add-reaction',
  AddToReport: 'add-to-report',
  AdminShieldSafe: 'admin-shield-safe',
  AmazonSagemaker: 'amazon-sagemaker',
  Area: 'area',
  ArtifactTypeAlt: 'artifact-type-alt',
  AudioVolume: 'audio-volume',
  AutomatedWorkspace: 'automated-workspace',
  AutomationRobotArm: 'automation-robot-arm',
  Back: 'back',
  BaselineAlt: 'baseline-alt',
  BaselinePennant: 'baseline-pennant',
  BellNotifications: 'bell-notifications',
  BenchmarkSquare: 'benchmark-square',
  BlogReport: 'blog-report',
  Bokeh: 'bokeh',
  Bold: 'bold',
  BookDictionary: 'book-dictionary',
  Boolean: 'boolean',
  BoxPlot: 'box-plot',
  BranchCommit: 'branch-commit',
  Bug: 'bug',
  BuzzBot10: 'buzz-bot10',
  CategoryMultimodal: 'category-multimodal',
  ChartHorizontalBars: 'chart-horizontal-bars',
  ChartPie: 'chart-pie',
  ChartScatterplot: 'chart-scatterplot',
  ChartVerticalBars: 'chart-vertical-bars',
  Checkmark: 'checkmark',
  CheckmarkCircle: 'checkmark-circle',
  ChevronBack: 'chevron-back',
  ChevronDown: 'chevron-down',
  ChevronNext: 'chevron-next',
  ChevronUp: 'chevron-up',
  Circle: 'circle',
  ClearAll: 'clear-all',
  Close: 'close',
  Cloud: 'cloud',
  CodeAlt: 'code-alt',
  Collapse: 'collapse',
  Color: 'color',
  Column: 'column',
  ContentFullWidth: 'content-full-width',
  ContentNarrow: 'content-narrow',
  ContentWide: 'content-wide',
  ContextWindow: 'context-window',
  ContractLeft: 'contract-left',
  Copy: 'copy',
  Cost: 'cost',
  CourthouseLicense: 'courthouse-license',
  CreditCardPayment: 'credit-card-payment',
  CropBeginning: 'crop-beginning',
  CropEnd: 'crop-end',
  CropMiddle: 'crop-middle',
  Cross: 'cross',
  CrownPro: 'crown-pro',
  CubeContainer: 'cube-container',
  DashboardBlackboard: 'dashboard-blackboard',
  DatabaseArtifacts: 'database-artifacts',
  Date: 'date',
  Delete: 'delete',
  Diamond: 'diamond',
  Diff: 'diff',
  DiscordSocial: 'discord-social',
  DockerWhale: 'docker-whale',
  Document: 'document',
  Documentation: 'documentation',
  Download: 'download',
  Draft: 'draft',
  DragGrip: 'drag-grip',
  DragGripHorizontal: 'drag-grip-horizontal',
  EducationAcademic: 'education-academic',
  EmailAt: 'email-at',
  EmailEnvelope: 'email-envelope',
  EnterReturn: 'enter-return',
  ExpandRight: 'expand-right',
  ExpandUncollapse: 'expand-uncollapse',
  ExportShareUpload: 'export-share-upload',
  FacebookSocial: 'facebook-social',
  Failed: 'failed',
  FilledCircle: 'filled-circle',
  FilterAlt: 'filter-alt',
  FlashBolt: 'flash-bolt',
  FolderAlt: 'folder-alt',
  FolderFill: 'folder-fill',
  FolderProject: 'folder-project',
  FolderProjectMove: 'folder-project-move',
  ForumChatBubble: 'forum-chat-bubble',
  ForwardNext: 'forward-next',
  FullScreenModeExpand: 'full-screen-mode-expand',
  GhostAgent: 'ghost-agent',
  Git: 'git',
  Github: 'github',
  Grafana: 'grafana',
  Group: 'group',
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  Headset: 'headset',
  Heart: 'heart',
  HeartFilled: 'heart-filled',
  HelpAlt: 'help-alt',
  HideHidden: 'hide-hidden',
  History: 'history',
  Home: 'home',
  Idle: 'idle',
  IgnoreOutliers: 'ignore-outliers',
  ImpersonateMaskAlt: 'impersonate-mask-alt',
  ImportInsert: 'import-insert',
  Inference: 'inference',
  Info: 'info',
  Intercom: 'intercom',
  Italic: 'italic',
  JobAutomation: 'job-automation',
  JobCalculator: 'job-calculator',
  JobProgramCode: 'job-program-code',
  JoyceTransformersLogo: 'joyce-transformers-logo',
  JoyceXgboostLogo: 'joyce-xgboost-logo',
  KerasLogo: 'keras-logo',
  KeyAdmin: 'key-admin',
  KeyAdminPrivate: 'key-admin-private',
  Keyboard: 'keyboard',
  Kubernetes: 'kubernetes',
  Languages: 'languages',
  LaptopLocalComputer: 'laptop-local-computer',
  LayoutGrid: 'layout-grid',
  LayoutHorizontal: 'layout-horizontal',
  LayoutTabs: 'layout-tabs',
  LayoutVertical: 'layout-vertical',
  Lightboard: 'lightboard',
  LightbulbInfo: 'lightbulb-info',
  LinePlotAlt2: 'line-plot-alt2',
  LinearScale: 'linear-scale',
  LinkAlt: 'link-alt',
  LinkedinSocial: 'linkedin-social',
  List: 'list',
  ListBullets: 'list-bullets',
  Loading: 'loading',
  LockClosed: 'lock-closed',
  LockOpen: 'lock-open',
  LockedConstrained: 'locked-constrained',
  LogOut: 'log-out',
  LogoColab: 'logo-colab',
  MagicWandStar: 'magic-wand-star',
  MagicWandStick: 'magic-wand-stick',
  Markdown: 'markdown',
  Marker: 'marker',
  Megaphone: 'megaphone',
  Menu: 'menu',
  MicrophoneAudio: 'microphone-audio',
  MillerColumns: 'miller-columns',
  MinimizeMode: 'minimize-mode',
  Model: 'model',
  ModelOnDark: 'model-on-dark',
  Molecule: 'molecule',
  Monitors: 'monitors',
  Moon: 'moon',
  MusicAudio: 'music-audio',
  NewSectionAbove: 'new-section-above',
  NewSectionBelow: 'new-section-below',
  NotVisible: 'not-visible',
  Notebook: 'notebook',
  Number: 'number',
  NumberedList: 'numbered-list',
  OpenNewTab: 'open-new-tab',
  OpenaiLogo: 'openai-logo',
  OrchestrationLaunch: 'orchestration-launch',
  OrganizationCorporate: 'organization-corporate',
  OverflowHorizontal: 'overflow-horizontal',
  OverflowVertical: 'overflow-vertical',
  Overlay2Column: 'overlay-2-column',
  Overlay3Column: 'overlay-3-column',
  OverlayStack: 'overlay-stack',
  PanTool: 'pan-tool',
  PanTool1: 'pan-tool-1',
  Panel: 'panel',
  PanelAutoGen: 'panel-auto-gen',
  PanelImages: 'panel-images',
  PanelManual: 'panel-manual',
  ParallelCoordinates: 'parallel-coordinates',
  ParentBackUp: 'parent-back-up',
  Pause: 'pause',
  Paused: 'paused',
  PencilEdit: 'pencil-edit',
  PennantPill: 'pennant-pill',
  PennantPillFilled: 'pennant-pill-filled',
  Photo: 'photo',
  Pin: 'pin',
  PinToLeft: 'pin-to-left',
  PinToLeftFilled: 'pin-to-left-filled',
  PinToRight: 'pin-to-right',
  Play: 'play',
  Plotly: 'plotly',
  PriorityCritical: 'priority-critical',
  PriorityHigh: 'priority-high',
  PriorityLow: 'priority-low',
  PriorityNone: 'priority-none',
  PrivacyOpen: 'privacy-open',
  PythonLogo: 'python-logo',
  PytorchLightningLogo: 'pytorch-lightning-logo',
  PytorchLogo: 'pytorch-logo',
  TypescriptLogo: 'typescript-logo',
  Queue: 'queue',
  Queued: 'queued',
  Randomize: 'randomize',
  RandomizeAlt: 'randomize-alt',
  RandomizeResetReload: 'randomize-reset-reload',
  RecentClock: 'recent-clock',
  RedditSocial: 'reddit-social',
  Redo: 'redo',
  Regex: 'regex',
  Registries: 'registries',
  ReloadRefresh: 'reload-refresh',
  Remove: 'remove',
  RemoveAlt: 'remove-alt',
  Report: 'report',
  Retry: 'retry',
  RobotServiceMember: 'robot-service-member',
  RocketLaunch: 'rocket-launch',
  RowHeightLarge: 'row-height-large',
  RowHeightMedium: 'row-height-medium',
  RowHeightSmall: 'row-height-small',
  RowHeightXlarge: 'row-height-xlarge',
  Run: 'run',
  RunningRepeat: 'running-repeat',
  SandboxPlayground: 'sandbox-playground',
  Save: 'save',
  ScikitLogo: 'scikit-logo',
  Search: 'search',
  SelectMoveTool: 'select-move-tool',
  Settings: 'settings',
  SettingsParameters: 'settings-parameters',
  ShareExport: 'share-export',
  ShareWith: 'share-with',
  ShieldRemove: 'shield-remove',
  ShowVisible: 'show-visible',
  Smoothing: 'smoothing',
  Sort: 'sort',
  SortAscending: 'sort-ascending',
  SortDescending: 'sort-descending',
  Spiral: 'spiral',
  Split: 'split',
  Square: 'square',
  Star: 'star',
  StarFilled: 'star-filled',
  Stop: 'stop',
  Stopped: 'stopped',
  Strikethrough: 'strikethrough',
  Sun: 'sun',
  Swap: 'swap',
  SweepBayes: 'sweep-bayes',
  SweepGrid: 'sweep-grid',
  SweepRandomSearch: 'sweep-random-search',
  SweepsAlt: 'sweeps-alt',
  SweepsBroom: 'sweeps-broom',
  SweepsBroomAlt: 'sweeps-broom-alt',
  System: 'system',
  SystemChip: 'system-chip',
  SystemChipAlt: 'system-chip-alt',
  Table: 'table',
  Tag: 'tag',
  TensorflowLogo: 'tensorflow-logo',
  TextLanguage: 'text-language',
  TextLanguageAlt: 'text-language-alt',
  Thread: 'thread',
  ThumbsDown: 'thumbs-down',
  ThumbsUp: 'thumbs-up',
  Timeline: 'timeline',
  TriangleDown: 'triangle-down',
  TriangleLeft: 'triangle-left',
  TriangleRight: 'triangle-right',
  TriangleUp: 'triangle-up',
  TriggerAlt: 'trigger-alt',
  Twitter: 'twitter',
  TypeBoolean: 'type-boolean',
  TypeNumber: 'type-number',
  TypeNumberAlt: 'type-number-alt',
  TypeStringAlt: 'type-string-alt',
  TypeStringQuote: 'type-string-quote',
  UndeterminateVisibility: 'undeterminate-visibility',
  Undo: 'undo',
  UnlockedUnconstrained: 'unlocked-unconstrained',
  UserAuthor: 'user-author',
  UserProfilePersonal: 'user-profile-personal',
  UsersTeam: 'users-team',
  VersionsLayers: 'versions-layers',
  VertexGCP: 'vertex-gcp',
  VideoPlay: 'video-play',
  ViewGlasses: 'view-glasses',
  Visible: 'visible',
  Wandb: 'wandb',
  Warning: 'warning',
  WarningAlt: 'warning-alt',
  Weave: 'weave',
  WeaveGroupBoard: 'weave-group-board',
  Webhook: 'webhook',
  Wrap: 'wrap',
  XAxiAlt: 'x-axi-alt',
  XAxis: 'x-axis',
  YoutubeSocial: 'youtube-social',
  ZoomInTool: 'zoom-in-tool',
} as const;

export type IconName = (typeof IconNames)[keyof typeof IconNames];
